<template>
  <div class="card">
    <div class="card-header">
      <div class="card-title d-flex align-items-center">
        <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
          <inline-svg src="media/icons/duotune/communication/com005.svg" />
        </span>
        <h3 class="fw-bold m-0 text-gray-800">Clientes</h3>
      </div>
      <div
        v-if="this.modal === true"
        class="btn btn-icon btn-sm btn-active-light-primary mt-6"
        data-bs-dismiss="modal"
        @click="this.$emit('fecharCliente', false)"
      >
        <span class="svg-icon svg-icon-1 svg-icon lh-0">
          <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
        </span>
      </div>
    </div>
    <div class="card-body p-0">
      <div
        v-if="this.errosValidacaoGeral.length"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  {{ value }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div
            v-if="!this.showFilter"
            class="d-flex align-items-center position-relative my-1"
          >
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisarClientes"
              v-model="tableData.search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid w-250px ps-15"
              placeholder="Pesquisar Clientes"
              @keydown="keydownPesquisa"
              autocomplete="off"
              type="search"
            />
          </div>
        </div>
        <div class="card-toolbar">
          <div
            v-if="checkedClientes.length === 0"
            class="d-flex justify-content-end"
            data-kt-customer-table-toolbar="base"
          >
            <button
              v-if="this.modal === false"
              @click="this.$refs.table.exportarExcel()"
              type="button"
              class="btn btn-sm btn-light-primary me-3"
            >
              <span class="svg-icon svg-icon-2">
                <inline-svg src="media/icons/duotune/arrows/arr078.svg" />
              </span>
              Exportar
            </button>
            <router-link
              v-if="this.adicionar && this.modal === false"
              to="/cadastros/clientes/editar"
              class="btn btn-sm btn-primary"
              id="btnAdicionarCliente"
              ><span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/general/gen041.svg" /></span
              >Adicionar</router-link
            >
            <button
              v-if="this.adicionar && this.modal === true"
              @click="this.$emit('adicionarCliente')"
              class="btn btn-sm btn-primary"
              id="btnAdicionarClienteModal"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/general/gen041.svg" /></span
              >Adicionar
            </button>
          </div>
          <div
            v-else
            class="d-flex justify-content-end align-items-center"
            data-kt-customer-table-toolbar="selected"
          >
            <div class="fw-bolder me-5">
              <span class="me-2">{{ checkedClientes.length }}</span
              >Selecionado(s)
            </div>
            <button
              v-if="this.excluir && this.modal === false"
              type="button"
              class="btn btn-sm btn-danger"
              @click="deleteSelecionados()"
            >
              Excluír Selecionado(s)
            </button>
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="table"
          id="tableConsultaClientes"
          :table-header="this.modal === false ? tableHeader : tableHeaderModal"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhum cliente encontrado"
          v-on:checked-rows="checkedClientes = $event"
          :colors="true"
          v-on:double-click="selecionarRegistro($event)"
          v-on:current-row-selected="currentRow = $event"
          :current-row="currentRow"
          @showFilter="this.showFilter = $event"
        >
          <template v-slot:cell-checkbox="{ row: cliente }">
            <div
              class="form-check form-check-sm form-check-custom form-check-solid"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="cliente.id"
                v-model="checkedClientes"
              />
            </div>
          </template>
          <template v-slot:cell-codigo="{ row: cliente }">
            {{ cliente.codigo }}
          </template>
          <template v-slot:cell-foto="{ row: cliente }">
            <div
              v-if="cliente.foto ? cliente.foto : ''"
              class="symbol symbol-50px"
            >
              <div
                class="symbol-label fs-2 fw-bold bg-light-dark"
                :style="{
                  'background-image': `url(${
                    this.$utils.getUrl() + cliente.foto
                  })`,
                }"
              ></div>
            </div>
            <div v-else class="symbol symbol-50px">
              <div :class="['symbol-label fs-2 fw-bold ' + cliente.color]">
                {{
                  cliente.nome ? cliente.nome.substring(0, 1).toUpperCase() : ""
                }}
              </div>
            </div>
          </template>
          <template v-slot:cell-nome="{ row: cliente }">
            <div class="min-w-150px">{{ cliente.nome }}</div>
          </template>
          <template v-slot:cell-fantasia="{ row: cliente }">
            <div class="min-w-150px">{{ cliente.fantasia }}</div>
          </template>
          <template v-slot:cell-contato="{ row: cliente }">
            <div class="min-w-100px">{{ cliente.contato }}</div>
          </template>
          <template v-slot:cell-cpf_cnpj="{ row: cliente }">
            <div class="min-w-150px">
              {{
                cliente.cpf_cnpj && cliente.cpf_cnpj.length === 11
                  ? this.$utils.setMask(
                      cliente.cpf_cnpj,
                      "###.###.###-##",
                      true
                    )
                  : this.$utils.setMask(
                      cliente.cpf_cnpj,
                      "##.###.###/####-##",
                      true
                    )
              }}
            </div>
          </template>
          <template v-slot:cell-ClienteEnderecoUf="{ row: cliente }">
            {{
              cliente.ClienteEndereco && cliente.ClienteEndereco[0]
                ? cliente.ClienteEndereco[0].uf
                : ""
            }}
          </template>
          <template v-slot:cell-ClienteEnderecoCidade="{ row: cliente }">
            {{
              cliente.ClienteEndereco && cliente.ClienteEndereco[0]
                ? cliente.ClienteEndereco[0].cidade
                : ""
            }}
          </template>
          <template v-slot:cell-ClienteTelefoneTelefone="{ row: cliente }">
            <div class="min-w-125px">
              {{
                cliente.ClienteTelefone && cliente.ClienteTelefone[0]
                  ? cliente.ClienteTelefone[0].telefone
                  : ""
              }}
            </div>
          </template>
          <template v-slot:cell-ClienteEmailEmail="{ row: cliente }">
            {{
              cliente.ClienteEmail && cliente.ClienteEmail[0]
                ? cliente.ClienteEmail[0].email
                : ""
            }}
          </template>
          <template v-slot:cell-acoes="{ row: cliente }">
            <div :class="[this.modal === true && 'min-w-200px']">
              <button
                v-if="this.modal === true"
                class="btn btn-sm btn-light-primary me-2"
                @click="selecionarRegistro(cliente)"
              >
                Selecionar
              </button>
              <button
                class="btn btn-sm btn-light btn-active-light-primary"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="top-end"
              >
                Ações
                <span class="svg-icon svg-icon-5 m-0">
                  <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
                </span>
              </button>
              <div
                v-if="this.editar || this.excluir"
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                data-kt-menu="true"
              >
                <div
                  v-if="this.editar && this.modal === false"
                  class="menu-item px-3"
                >
                  <a @click="editarRegistro(cliente.id)" class="menu-link px-3"
                    >Editar</a
                  >
                </div>
                <div
                  v-if="this.editar && this.modal === true"
                  class="menu-item px-3"
                >
                  <a
                    @click="this.$emit('editarCliente', cliente.id)"
                    class="menu-link px-3"
                    >Editar</a
                  >
                </div>
                <div v-if="this.excluir" class="menu-item px-3">
                  <a @click="removerRegistro(cliente.id)" class="menu-link px-3"
                    >Excluír</a
                  >
                </div>
              </div>
            </div>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: [
    "selecionarCliente",
    "fecharCliente",
    "adicionarCliente",
    "editarCliente",
  ],
  components: {
    Datatable,
  },
  props: {
    modal: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(nome, '" +
          pesquisa +
          "') or contains(fantasia, '" +
          pesquisa +
          "') or contains(contato, '" +
          pesquisa +
          "') or contains(cpf_cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or ClienteEndereco/any(c: contains(c/cidade, '" +
          pesquisa +
          "')) or ClienteEndereco/any(c: contains(c/uf, '" +
          pesquisa +
          "')) or ClienteTelefone/any(c: contains(c/telefone, '" +
          pesquisa +
          "')) or ClienteEmail/any(c: contains(c/email, '" +
          pesquisa +
          "')) ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or codigo eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    async deleteSelecionados() {
      var alert = await Swal.fire({
        text: "Deseja remover os registros selecionados?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiuCadastro = true;
        this.$refs.table.setLoading(true);
        for (var i = 0; i < this.checkedClientes.length; i++) {
          await this.excluirCliente(this.checkedClientes[i]);
        }
        if (this.excluiuCadastro === true) {
          toast.success("Clientes excluídos com sucesso!", { timeout: 3000 });
        }
        this.$refs.table.load();
      }
    },
    async removerRegistro(id) {
      var alert = await Swal.fire({
        text: "Deseja remover o registro?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiuCadastro = true;
        this.$refs.table.setLoading(true);
        await this.excluirCliente(id);
        if (this.excluiuCadastro === true) {
          toast.success("Cliente excluído com sucesso!", { timeout: 3000 });
        }
        this.$refs.table.load();
      }
    },
    async excluirCliente(id) {
      var cliente = null;
      try {
        var ret = await this.$store.dispatch("cliente/getCliente", id);
        if (ret.Success === true) {
          cliente = ret.Data;
        }
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }

      for (var i = 0; i < cliente.ClienteEndereco.length; i++) {
        try {
          await this.$store.dispatch(
            "clienteEndereco/deleteClienteEndereco",
            cliente.ClienteEndereco[i].id
          );
        } catch (error) {
          this.excluiuCadastro = false;
          this.errosValidacaoGeral.push(error.Message);
        }
      }

      for (var y = 0; y < cliente.ClienteTelefone.length; y++) {
        try {
          await this.$store.dispatch(
            "clienteTelefone/deleteClienteTelefone",
            cliente.ClienteTelefone[y].id
          );
        } catch (error) {
          this.excluiuCadastro = false;
          this.errosValidacaoGeral.push(error.Message);
        }
      }

      for (var z = 0; z < cliente.ClienteEmail.length; z++) {
        try {
          await this.$store.dispatch(
            "clienteEmail/deleteClienteEmail",
            cliente.ClienteEmail[z].id
          );
        } catch (error) {
          this.excluiuCadastro = false;
          this.errosValidacaoGeral.push(error.Message);
        }
      }

      try {
        await this.$store.dispatch("cliente/deleteCliente", id);
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    editarRegistro(id) {
      this.$router.push("/cadastros/clientes/editar/" + id);
    },
    selecionarRegistro(cliente) {
      this.$emit("selecionarCliente", cliente);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.Cliente.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.Cliente.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.Cliente.Excluir") {
            this.excluir = true;
          }
        });
      }
    },
    async keydownPesquisa(e) {
      //console.log(e.key);
      if (e.key === "ArrowUp") {
        e.preventDefault();
        this.currentRow -= 1;
        if (this.currentRow < 0) {
          this.currentRow = 0;
        }
        this.$refs.table.setCurrentRow(this.currentRow);
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        this.currentRow += 1;
        this.$refs.table.setCurrentRow(this.currentRow);
      } else if (e.key === "Enter") {
        e.preventDefault();
        let cliente = this.$refs.table.getCurrentItemIndex(this.currentRow);
        this.selecionarRegistro(cliente);
      }
    },
    async exibirTour() {
      try {
        var ret = await this.$store.dispatch(
          "assistenteModulos/getAssistenteModulosOData",
          "?$select=modulo&$filter=modulo eq 'ConsultarClientes' and usuario eq " +
            this.user.User.id
        );
        if (ret.value !== null && ret.value.length > 0) {
          return true;
        }
      } catch (error) {
        console.log(error);
        return true;
      }
      return false;
    },
    async startTour() {
      this.tour = this.$shepherd({
        useModalOverlay: true,
        defaultStepOptions: {
          classes: "shadow-md bg-purple-dark",
          cancelIcon: {
            enabled: true,
            iconClass: "fas fa-times",
          },
        },
      });

      const mensagem = `<h3 style="text-align:center">Consulta de Clientes</h3>
                        <br/>
                        <p style="text-align:center">Percebemos que você é novo por aqui, então iremos te mostrar as principais funcionalidades do módulo.</p>
                        <p style="text-align:center">Antes de começar, é importante destacar que todos os módulos seguem a mesma linha de raciocínio, então ao aprender como um deles funciona, servirá para todos os outros.</p>
                        <p style="text-align:center"><img alt="" src="media/svg/illustrations/easy/6.svg"/></p>
                        <p>Clique no botão <strong>"Começar tour"</strong> abaixo para iniciar o tour.</p>`;

      this.tour.addStep({
        text: mensagem,
        buttons: [
          {
            text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Sair',
            action: this.tour.cancel,
            secondary: true,
          },
          {
            text: 'Começar tour<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
            action: this.tour.next,
            secondary: false,
          },
        ],
      });

      const windowWidth = window.innerWidth;

      if (windowWidth >= 768) {
        //Desktop

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("txtPesquisarClientes"),
            on: "right",
          },
          text: "Aqui você poderá fazer a pesquisa do cliente, digitando seu nome, fantasia, CPF/CNPJ.",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("btnAdicionarCliente"),
            on: "right",
          },
          text: "Você pode adicionar novos clientes clicando aqui.",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });

        this.tour.addStep({
          attachTo: {
            element: document.getElementById("tableConsultaClientes"),
            on: "bottom",
          },
          text: "Aqui serão exibidos os clientes já cadastrados.",
          buttons: [
            {
              text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Próximo<i class="fas fa-arrow-alt-circle-right ms-2"></i> ',
              action: this.tour.next,
              secondary: false,
            },
          ],
        });
      }
      this.tour.addStep({
        attachTo: {},
        text: `<h3 style="text-align:center">Pronto!</h3>
                        <br/>
                        <p style="text-align:center">Esta é a visão geral do cadastro de clientes, você pode consultar mais funcionalidades na nossa seção de ajuda.</p>                        
                        <p style="text-align:center"><img alt="" src="media/svg/illustrations/Complete-task.svg" style="width:100%;height:100%"/></p>`,
        buttons: [
          {
            text: '<i class="fas fa-arrow-alt-circle-left me-2"></i>Voltar',
            action: this.tour.back,
            secondary: true,
          },
          {
            text: 'Finalizar Tour<i class="fas fa-check-circle ms-2"></i> ',
            action: this.tour.next,
            secondary: false,
          },
        ],
      });
      this.tour.on("complete", async () => {
        if ((await this.exibirTour()) === false) {
          let assistente = {
            modulo: "ConsultarClientes",
            usuario: this.user.User.id,
          };

          try {
            var ret = await this.$store.dispatch(
              "assistenteModulos/postAssistenteModulos",
              assistente
            );
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    setTimeout(() => {
      this.nextFocus("txtPesquisarClientes");
    }, 800);

    if (
      this.user.User &&
      this.user.User.assistente_boas_vindas &&
      this.user.User.assistente_boas_vindas === "1"
    ) {
      if ((await this.exibirTour()) === false) {
        this.startTour();
        this.tour.start();
      }
    }
  },
  data() {
    return {
      showFilter: false,
      adicionar: false,
      editar: false,
      excluir: false,
      checkedClientes: [],
      currentRow: 0,
      errosValidacaoGeral: [],
      excluiuCadastro: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "Código",
          key: "codigo",
          sortable: true,
        },
        {
          key: "foto",
          sortable: false,
        },
        {
          name: "Nome",
          key: "nome",
          sortable: true,
        },
        {
          name: "Fantasia",
          key: "fantasia",
          sortable: true,
        },
        {
          name: "Contato",
          key: "contato",
          sortable: true,
        },
        {
          name: "CPF/CNPJ",
          key: "cpf_cnpj",
          sortable: true,
        },
        {
          name: "UF",
          key: "ClienteEnderecoUf",
          sortingField: "ClienteEndereco/uf",
          sortable: false,
        },
        {
          name: "Cidade",
          key: "ClienteEnderecoCidade",
          sortingField: "ClienteEndereco/cidade",
          sortable: false,
        },
        {
          name: "Telefone",
          key: "ClienteTelefoneTelefone",
          sortingField: "ClienteTelefone/telefone",
          sortable: false,
        },
        {
          name: "Email",
          key: "ClienteEmailEmail",
          sortingField: "ClienteEmail/email",
          sortable: false,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableHeaderModal: [
        {
          name: "Código",
          key: "codigo",
          sortable: true,
        },
        {
          key: "foto",
          sortable: false,
        },
        {
          name: "Nome",
          key: "nome",
          sortable: true,
        },
        {
          name: "Fantasia",
          key: "fantasia",
          sortable: true,
        },
        {
          name: "CPF/CNPJ",
          key: "cpf_cnpj",
          sortable: true,
        },
        {
          name: "UF",
          key: "ClienteEnderecoUf",
          sortingField: "ClienteEndereco/uf",
          sortable: false,
        },
        {
          name: "Cidade",
          key: "ClienteEnderecoCidade",
          sortingField: "ClienteEndereco/cidade",
          sortable: false,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "cliente/getClienteOData",
        selectOData:
          "?$select=id,codigo,nome,fantasia,contato,cpf_cnpj,foto&$expand=ClienteTelefone($select=telefone),ClienteEmail($select=email),ClienteEndereco($select=uf,cidade)",
        filterOData: "",
        search: "",
        defaultSort: "codigo asc",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style>
.shepherd-footer {
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.shepherd-button i.fas.fa-arrow-alt-circle-right {
  color: hsla(0, 0%, 100%, 0.75);
}

.shepherd-button i.fas.fa-check-circle {
  color: hsla(0, 0%, 100%, 0.75);
}
</style>
